class LandingPageTextCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.section = this;

    this.swiper = {};
    this.swiperElement = this.section.querySelector(
      ".text-carousel--container"
    );
    this.swiperPagination = this.section.querySelector(".swiper-pagination");

    this.initSlider();
  }
  disconnectedCallback() {}

  initSlider() {
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination, Autoplay } = _ref;
      this.swiper = new Swiper(this.swiperElement, {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 4,
        resistance: false,
        loop: true,
        pagination: {
          el: this.swiperPagination,
          clickable: true,
        },
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      });
    });
  }
}
customElements.define("landing-page-text-carousel", LandingPageTextCarousel);
